<template>
  <div>
    <b-form-group label="Supplier identity" :label-for="id('supplier')" description="Optional exact Emerald ID. Names and addresses do not merge records.">
      <b-form-input :id="id('supplier')" :value="value.source_record_id" maxlength="64" @input="update('source_record_id', $event)"/>
    </b-form-group>
    <div class="row">
      <b-form-group v-for="field in primaryFields" :key="field" :label="label(field)" :label-for="id(field)" class="col-sm-6">
        <b-form-input :id="id(field)" :value="value.fields[field]" @input="fieldValue(field, $event)"/>
      </b-form-group>
    </div>
    <details v-if="value.type !== 'contact'" class="mb-3">
      <summary>{{ value.type === 'company' ? 'Establishment address' : 'Physical address' }}</summary>
      <div class="row mt-2">
        <b-form-group v-for="field in addressFields" :key="field" :label="label(field)" :label-for="id(field)" class="col-sm-6">
          <b-form-input :id="id(field)" :value="value.fields[field]" :maxlength="field === 'state' ? 2 : null" @input="fieldValue(field, $event)"/>
        </b-form-group>
      </div>
    </details>
    <details class="mb-3">
      <summary>Contact details</summary>
      <template v-if="value.type !== 'contact'">
        <fieldset v-for="field in ['emails', 'phones']" :key="field" class="mt-2">
          <legend class="h6">{{ label(field) }}</legend>
          <div v-for="(row, index) in channels(field)" :key="row.id" class="d-flex mb-2">
            <label class="sr-only" :for="id(`${field}-${index}`)">{{ label(field) }} {{ index + 1 }}</label>
            <b-form-input :id="id(`${field}-${index}`)" :value="row.value" @input="channelValue(field, row, $event)"/>
            <b-btn type="button" size="sm" variant="link" :aria-label="`Remove ${field} ${index + 1}`" @click="removeChannel(field, row)">Remove</b-btn>
          </div>
          <b-btn type="button" size="sm" variant="outline-secondary" @click="addChannel(field)">Add {{ field === 'emails' ? 'email' : 'phone' }}</b-btn>
        </fieldset>
      </template>
      <b-form-group v-for="field in contactFields" :key="field" :label="label(field)" :label-for="id(field)" class="mt-2">
        <b-form-input :id="id(field)" :value="value.fields[field]" @input="fieldValue(field, $event)"/>
      </b-form-group>
    </details>
    <p class="small text-muted">Imports for this record replace initial details. Later corrections stay.</p>
  </div>
</template>
<script>
import {label} from "./RegistryOperationSupport";
// Unique across forms so a row keeps its key when another row is added, removed or edited.
let nextAddedRow = 0;
const PRIMARY = {location: ["legal_name", "common_name", "state_of_operation"], company: ["legal_name", "common_name", "company_name", "states_of_operation"], contact: ["first_name", "last_name", "full_name", "titles", "city", "state"]};
export default {
  name: "RegistryActionEntityFields",
  props: {value: {type: Object, required: true}},
  data: () => ({addressFields: ["address_1", "address_2", "city", "county", "state", "zip", "country"]}),
  computed: {
    primaryFields() { return PRIMARY[this.value.type] || []; },
    contactFields() { return this.value.type === "contact" ? ["primary_email", "primary_phone"] : ["website"]; }
  },
  methods: {
    label,
    id(field) { return `registry-create-${this._uid}-${field}`; },
    update(key, value) { this.$emit("input", {...this.value, [key]: value}); },
    fieldValue(field, value) { this.update("fields", {...this.value.fields, [field]: value}); },
    // Edited rows stay as ordered drafts until entityCreation serializes them. An untouched prefilled scalar is only displayed.
    channels(field) {
      const drafts = this.value.channels || {};
      if (drafts[field]) return drafts[field];
      const value = this.value.fields[field];
      return value == null ? [] : String(value).split(",").map((entry, index) => ({id: `source-${index}`, value: entry.trim()}));
    },
    editChannels(field, rows) { this.update("channels", {...this.value.channels, [field]: rows}); },
    channelValue(field, row, value) { this.editChannels(field, this.channels(field).map(item => item.id === row.id ? {...item, value} : item)); },
    addChannel(field) { this.editChannels(field, [...this.channels(field), {id: `added-${nextAddedRow++}`, value: ""}]); },
    removeChannel(field, row) { this.editChannels(field, this.channels(field).filter(item => item.id !== row.id)); }
  }
};
</script>
